import { render, staticRenderFns } from "./BusinessDetailsField.vue?vue&type=template&id=236c131e&scoped=true"
import script from "./BusinessDetailsField.vue?vue&type=script&lang=ts"
export * from "./BusinessDetailsField.vue?vue&type=script&lang=ts"
import style0 from "./BusinessDetailsField.vue?vue&type=style&index=0&id=236c131e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "236c131e",
  null
  
)

export default component.exports